<div #chartOutput [ngClass]="styles.chartOutput" [hidden]="!chart?.data?.length">
</div>

<div #legendOutput [hidden]="!scrollableLegend" [ngClass]="styles.legendOutput">
</div>

<div [ngClass]="styles.noData" [hidden]="chart?.data?.length">
	{{ 'UI_Chart_NoDataAvailable' | translate }}
</div>